"use strict";
exports.__esModule = true;
exports.reflect = void 0;
var reflect = function (declare) {
    declare("CosmosLikeTransactionBuilder", {
        methods: {
            addMessage: {
                params: ["CosmosLikeMessage"]
            },
            build: {
                returns: "CosmosLikeTransaction"
            },
            setMemo: {},
            setSequence: {},
            setAccountNumber: {},
            setFee: {
                params: ["Amount"]
            },
            setGas: {
                params: ["Amount"]
            }
        }
    });
    declare("CosmosGasLimitRequest", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, ["CosmosLikeMessage"], null],
                returns: "CosmosGasLimitRequest",
                njsInstanciateClass: [
                    {
                        memo: 0,
                        messages: 1,
                        amplifier: 2
                    },
                ]
            }
        }
    });
    declare("CosmosLikeAccount", {
        methods: {
            estimateGas: {
                params: ["CosmosGasLimitRequest"],
                returns: "BigInt"
            },
            buildTransaction: {
                returns: "CosmosLikeTransactionBuilder"
            },
            broadcastRawTransaction: {},
            broadcastTransaction: {},
            getEstimatedGasLimit: {
                params: ["CosmosLikeTransaction"]
            },
            getSequence: {},
            getAccountNumber: {},
            getPendingRewards: {
                returns: ["CosmosLikeReward"]
            },
            getRedelegations: {
                returns: ["CosmosLikeRedelegation"]
            },
            getUnbondings: {
                returns: ["CosmosLikeUnbonding"]
            },
            getDelegations: {
                returns: ["CosmosLikeDelegation"]
            },
            getValidatorInfo: {
                returns: "CosmosLikeValidator"
            }
        }
    });
    declare("CosmosLikeValidator", {
        njsUsesPlainObject: true,
        methods: {
            getActiveStatus: {
                njsField: "activeStatus"
            }
        }
    });
    declare("CosmosLikeReward", {
        methods: {
            getDelegatorAddress: {},
            getValidatorAddress: {},
            getRewardAmount: {
                returns: "Amount"
            }
        }
    });
    declare("CosmosLikeUnbonding", {
        methods: {
            getDelegatorAddress: {},
            getValidatorAddress: {},
            getEntries: {
                returns: ["CosmosLikeUnbondingEntry"]
            }
        }
    });
    declare("CosmosLikeTransaction", {
        methods: {
            getHash: {},
            getMemo: {},
            setDERSignature: {
                params: ["hex"]
            },
            getFee: {
                returns: "Amount"
            },
            getGas: {
                returns: "Amount"
            },
            serializeForSignature: {},
            serializeForBroadcast: {}
        }
    });
    declare("CosmosLikeOperation", {
        methods: {
            getTransaction: {
                returns: "CosmosLikeTransaction"
            },
            getMessage: {
                returns: "CosmosLikeMessage"
            }
        }
    });
    declare("CosmosLikeRedelegationEntry", {
        methods: {
            getInitialBalance: {
                returns: "BigInt"
            },
            getCompletionTime: {}
        }
    });
    declare("CosmosLikeUnbondingEntry", {
        methods: {
            getInitialBalance: {
                returns: "BigInt"
            },
            getCompletionTime: {}
        }
    });
    declare("CosmosLikeRedelegation", {
        methods: {
            getDelegatorAddress: {
                returns: "string"
            },
            getSrcValidatorAddress: {
                returns: "string"
            },
            getDstValidatorAddress: {
                returns: "string"
            },
            getEntries: {
                returns: ["CosmosLikeRedelegationEntry"]
            }
        }
    });
    declare("CosmosLikeDelegation", {
        methods: {
            getDelegatorAddress: {},
            getValidatorAddress: {},
            getDelegatedAmount: {
                returns: "Amount"
            }
        }
    });
    declare("CosmosLikeMessage", {
        statics: {
            wrapMsgSend: {
                params: ["CosmosLikeMsgSend"],
                returns: "CosmosLikeMessage",
                njsBuggyMethodIsNotStatic: true
            },
            wrapMsgDelegate: {
                params: ["CosmosLikeMsgDelegate"],
                returns: "CosmosLikeMessage",
                njsBuggyMethodIsNotStatic: true
            },
            wrapMsgUndelegate: {
                params: ["CosmosLikeMsgUndelegate"],
                returns: "CosmosLikeMessage",
                njsBuggyMethodIsNotStatic: true
            },
            wrapMsgBeginRedelegate: {
                params: ["CosmosLikeMsgBeginRedelegate"],
                returns: "CosmosLikeMessage",
                njsBuggyMethodIsNotStatic: true
            },
            wrapMsgWithdrawDelegationReward: {
                params: ["CosmosLikeMsgWithdrawDelegationReward"],
                returns: "CosmosLikeMessage",
                njsBuggyMethodIsNotStatic: true
            },
            unwrapMsgDelegate: {
                params: ["CosmosLikeMessage"],
                returns: "CosmosLikeMsgDelegate",
                njsBuggyMethodIsNotStatic: true
            },
            unwrapMsgBeginRedelegate: {
                params: ["CosmosLikeMessage"],
                returns: "CosmosLikeMsgBeginRedelegate",
                njsBuggyMethodIsNotStatic: true
            },
            unwrapMsgUndelegate: {
                params: ["CosmosLikeMessage"],
                returns: "CosmosLikeMsgUndelegate",
                njsBuggyMethodIsNotStatic: true
            },
            unwrapMsgWithdrawDelegationReward: {
                params: ["CosmosLikeMessage"],
                returns: "CosmosLikeMsgWithdrawDelegationReward",
                njsBuggyMethodIsNotStatic: true
            }
        },
        methods: {
            getMessageType: {},
            getRawMessageType: {},
            getIndex: {}
        }
    });
    declare("CosmosLikeAmount", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null],
                returns: "CosmosLikeAmount",
                njsInstanciateClass: [
                    {
                        amount: 0,
                        denom: 1
                    },
                ]
            }
        },
        methods: {
            getAmount: {
                njsField: "amount"
            }
        }
    });
    declare("CosmosLikeMsgSend", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, ["CosmosLikeAmount"]],
                returns: "CosmosLikeMsgSend",
                njsInstanciateClass: [
                    {
                        fromAddress: 0,
                        toAddress: 1,
                        amount: 2
                    },
                ]
            }
        }
    });
    declare("CosmosLikeMsgDelegate", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, "CosmosLikeAmount"],
                returns: "CosmosLikeMsgDelegate",
                njsInstanciateClass: [
                    {
                        delegatorAddress: 0,
                        validatorAddress: 1,
                        amount: 2
                    },
                ]
            }
        },
        methods: {
            getValidatorAddress: {
                njsField: "validatorAddress"
            },
            getAmount: {
                njsField: "amount",
                returns: "CosmosLikeAmount"
            }
        }
    });
    declare("CosmosLikeMsgBeginRedelegate", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, null, "CosmosLikeAmount"],
                returns: "CosmosLikeMsgBeginRedelegate",
                njsInstanciateClass: [
                    {
                        delegatorAddress: 0,
                        validatorSourceAddress: 1,
                        validatorDestinationAddress: 2,
                        amount: 3
                    },
                ]
            }
        },
        methods: {
            getValidatorDestinationAddress: {
                njsField: "validatorDestinationAddress"
            },
            getValidatorSourceAddress: {
                njsField: "validatorSourceAddress"
            },
            getAmount: {
                njsField: "amount",
                returns: "CosmosLikeAmount"
            }
        }
    });
    declare("CosmosLikeMsgUndelegate", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, "CosmosLikeAmount"],
                returns: "CosmosLikeMsgUndelegate",
                njsInstanciateClass: [
                    {
                        delegatorAddress: 0,
                        validatorAddress: 1,
                        amount: 2
                    },
                ]
            }
        },
        methods: {
            getValidatorAddress: {
                njsField: "validatorAddress"
            },
            getAmount: {
                njsField: "amount",
                returns: "CosmosLikeAmount"
            }
        }
    });
    declare("CosmosLikeMsgWithdrawDelegationReward", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null],
                returns: "CosmosLikeMsgWithdrawDelegationReward",
                njsInstanciateClass: [
                    {
                        delegatorAddress: 0,
                        validatorAddress: 1
                    },
                ]
            }
        },
        methods: {
            getDelegatorAddress: {
                njsField: "delegatorAddress"
            },
            getValidatorAddress: {
                njsField: "validatorAddress"
            }
        }
    });
    return {
        OperationMethods: {
            asCosmosLikeOperation: {
                returns: "CosmosLikeOperation"
            }
        },
        AccountMethods: {
            asCosmosLikeAccount: {
                returns: "CosmosLikeAccount"
            }
        }
    };
};
exports.reflect = reflect;
//# sourceMappingURL=types.js.map